import { getOrderStatus, createOrder, createPayWithInvoice, deleteOrder, updateOrder } from "../api/payment";
import { getUserSub } from "./auth";
import { readShoppingCart, writeShoppingCart } from "./shoppingCartStorage";

// Stored per signed-in user (keyed by Keycloak subject) and removed on logout, see shoppingCartStorage.
const currentUserId = () => getUserSub() || "anonymous";

const ShoppingCart = {
  _set(crewId, order) {
    const stored = readShoppingCart(currentUserId());
    stored[crewId] = order;
    writeShoppingCart(currentUserId(), stored);
  },
  _get(crewId) {
    return readShoppingCart(currentUserId())[crewId] ?? null;
  },
  getCrewItems(crewId) {
    const order = this._get(crewId);
    return order?.items || [];
  },
  async updateOrderStatus(crewId) {
    const order = this._get(crewId);
    if (order?.orderId) {
      const status = await getOrderStatus(order.orderId);
      if (status.status === "paid") {
        this._set(crewId, null);
      }
    }
  },
  async clear(crewId) {
    /*const order = this._get(crewId);
    if (order?.orderId) {
      await deleteOrder(order.orderId);
    }*/
    this._set(crewId, null);
  },
  async add(crewId, item) {
    const order = this._get(crewId) || { items: [] };
    if (!order.items.find((i) => i.courseId === item.courseId && i.userId === item.userId)) {
      order.items.push(item);
      this._set(crewId, order);
    }
    if (order?.orderId) {
      await updateOrder(order.orderId, order.items);
    }
  },
  async removeItem(crewId, item) {
    const order = this._get(crewId);
    if (order) {
      order.items = order.items.filter((i) => !(i.courseId === item.courseId && i.userId === item.userId));
      this._set(crewId, order);
    }
    if (order?.orderId) {
      await updateOrder(order.orderId, order.items);
    }
  },
  setOrderId(crewId, orderId) {
    const order = this._get(crewId);
    this._set(crewId, { ...order, orderId });
  },
  async checkout(crewId, billingId) {
    /*const order = this._get(crewId);
    if (order.orderId) {
      await updateOrder(order.orderId, order.items);
      const status = await getOrderStatus(order.orderId);
      return status;
    } else {
      const items = this.getCrewItems(crewId);
      const newOrder = await createOrder(items);
      this.setOrderId(crewId, newOrder?.orderId);
      return newOrder;
    }*/
    const items = this.getCrewItems(crewId);
    const newOrder = await createOrder(items, billingId);
    return newOrder;
  },
  async payWithInvoice(crewId, billingId, shoppingItems) {
    const items = this.getCrewItems(crewId);
    const newPayWithInvoice = await createPayWithInvoice(items, billingId, shoppingItems, "processing");
    return newPayWithInvoice;
  },
};

export default ShoppingCart;
